import { BaseDifferential, Complaint } from '../utils/dataTypes';
import { pimsApi } from './pimsApi';

// Define a service using a base URL and expected endpoints
export const problemDiffApi = pimsApi.injectEndpoints({
	endpoints: (builder) => ({
		searchComplaints: builder.query<Complaint[], string>({
			query: (searchQuery) => `complaint/search?query=${searchQuery}`,
			transformResponse: (response: { data: Complaint[] }) =>
				response.data,
		}),
		searchDifferentials: builder.query<BaseDifferential[], string>({
			query: (searchQuery) => `differential/search?query=${searchQuery}`,
			transformResponse: (response: { data: BaseDifferential[] }) =>
				response.data,
		}),
	}),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints

export const { useSearchComplaintsQuery, useSearchDifferentialsQuery } =
	problemDiffApi;
